import { cloneDeep } from "lodash";
import React, { useContext, useState } from "react";
import { useQuery } from "react-query";
import { constants } from "shared/constants";
import pl from "shared/messages/pl";
import { EntityNoteHeader_PublicEntityType } from "shared/service/api/generated";
import { ResizerContext } from "shared/stores/resizeStore/ResizerContext";
import { NoteSubjectTypeEnum } from "view360Card/models";
import NotesService from "../service/NotesService";
import { NoteDetailsFormReadOnly } from "./note-details-form/NoteDetailsForm";
import NotesListWrapper from "./notes-list/NotesListWrapper";
import NotesTabContent from "./NotesTabContent";
import {
    Loader,
} from "@fluentui/react-northstar";
import EmptyContent from "view360Card/components/emptyContent/EmptyContent";

const ViewGlobalNotes: React.FC = () => {
    const resizeContext = useContext(ResizerContext);
    const isMobile = resizeContext.windowWidth < constants.view360MobileDeviceWidthPx;
    const [mobileFullScreenViewOpened, setMobileFullScreenViewOpened] = useState(true);
    const [selectedNoteId, setSelectedNoteId] = useState<number>();
    const [entityType, setEntitytype] = useState<EntityNoteHeader_PublicEntityType>();
    const [entityId, setEntityId] = useState<number>();

    const noteTypesQuery = useQuery("noteTypes2", async () => {
        return await NotesService.getAvailableNoteTypes();
    });

    const noteTypeList = cloneDeep(noteTypesQuery.data);

    const noteSubjectsRetailQuery = useQuery("globalNoteSubjects", async () => {
        return await NotesService.getAvailableNoteSubjects();
    });

    const noteAuthorsQuery = useQuery("globalNoteAuthors", async () => {
        return await NotesService.getAvailableNoteAuthors();
    })

    const noteQuery = useQuery(["note", selectedNoteId], async () => {
        let note;

        if(selectedNoteId && entityId){
            if (entityType === EntityNoteHeader_PublicEntityType.OFWCA) {
                note = await NotesService.getSalesPersonNoteDetails(entityId, selectedNoteId);
            }

            if (entityType === EntityNoteHeader_PublicEntityType.INTERMEDIARY) {
                note = await NotesService.getIntermediaryNoteDetails(entityId, selectedNoteId);
            }
        }

        return note;
    });

    const loadingInProgress =
        noteSubjectsRetailQuery.isFetching ||
        noteAuthorsQuery.isFetching ||
        noteQuery.isFetching;

    const getNoteList = () => {
        return (
            <NotesListWrapper
                availableNoteTypes={noteTypeList}
                availableNoteRetailSubjects={noteSubjectsRetailQuery.data}
                availableNoteAuthors={noteAuthorsQuery.data}
                salesPersonId={undefined}
                intermediaryId={undefined}
                isV360View={false}
                selectedNoteId={selectedNoteId}
                onAddNoteButtonClicked={() => setSelectedNoteId(undefined)}
                onNoteSelected={(noteId, entityType, entityId) => {
                    setSelectedNoteId(noteId);
                    setEntitytype(entityType);
                    setEntityId(entityId);
                    if (noteId) {
                        setMobileFullScreenViewOpened(false);
                    }
                }}
            />
        );
    };

    const getNoteDetailsForm = () => {
        return (
            !selectedNoteId
            ? <EmptyContent message={pl.notes.selectNote} graphic="empty" />
            : loadingInProgress
            ? <div style={{height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Loader label={pl.common.appLoading} />
            </div>
            : <NoteDetailsFormReadOnly
                isEditable={false}
                noteDetails={noteQuery.data}
            />
        );
    };

    return (
        <NotesTabContent
            isMobile={isMobile}
            isEditNoteEnabled={false}
            notesList={getNoteList()}
            noteDetailsForm={
                getNoteDetailsForm()
            }
            deleteNote={() => {}}
            mobileFullScreenViewOpened={mobileFullScreenViewOpened}
            setMobileFullScreenViewOpened={(open) => setMobileFullScreenViewOpened(open)}
            selectedNoteId={selectedNoteId}
            setSelectedNoteId={(noteId) => 
                setSelectedNoteId(noteId)
            }
            canNoteBeDeleted={false}
            isInEditMode={false}
            setEditMode={(editMode) => {}}
        />
    )
}

export default ViewGlobalNotes;